export const DASHBOARD_ROUTES = {
  settings: "/dashboard/digital-brain-settings",
  schedule: "/dashboard/digital-brain-schedule",
};
